<template>
  <div class="field field--checkbox">
    <label
    :class="{'field--checked':isChecked}"
    ><input type="checkbox" @click="toggle" :checked="isChecked" />
      <div class="checkbox__indicator"></div>
      {{displayLabel}}
    </label>
  </div>
</template>
<script>
export default {
  props: {
    live: Boolean,
    type: String,
    entity: String
  },
  data() {
    return {
      isChecked: this.live,
    }
  },
  computed: {
    displayLabel(){
      if (this.entity === "ApplicationArticle") return "Industry Application";

      return decodeURIComponent(this.entity).replace(/([A-Z])/g, ' $1').trim();
    }
  },
  methods: {
    toggle(){
      if (this.isChecked) {
        this.$emit('remove-selection', this.type, this.entity);
      } else {
        this.$emit('add-selection', this.type, this.entity);
      }
      this.isChecked = !this.isChecked;
    }
  }
}
</script>
